import { c as _c } from "react/compiler-runtime";
import type { Dispatch, SetStateAction } from 'react';
import { useCallback, useState } from 'react';
import type { CartShop } from '../_components/CartShopGroup';
interface UseCartOptimisticParams {
  shops: CartShop[];
  setShops: Dispatch<SetStateAction<CartShop[]>>;
  updateQuantity: (cartItemId: string, quantity: number) => Promise<unknown>;
  deleteItems: (cartItemIds: string[]) => Promise<unknown>;
}
export const useCartOptimistic = t0 => {
  const $ = _c(15);
  const {
    shops,
    setShops,
    updateQuantity,
    deleteItems
  } = t0;
  const [removeTarget, setRemoveTarget] = useState(null);
  let t1;
  if ($[0] !== deleteItems || $[1] !== setShops || $[2] !== updateQuantity) {
    t1 = (mallVendorId, mallProductId, cartItemOptionId, quantity) => {
      if (!cartItemOptionId) {
        return;
      }
      if (quantity < 1) {
        deleteItems([cartItemOptionId]);
        setShops(prev => prev.map(shop => {
          if (shop.mallVendorId !== mallVendorId) {
            return shop;
          }
          return {
            ...shop,
            products: shop.products.map(p => {
              if (p.mallProductId !== mallProductId) {
                return p;
              }
              return {
                ...p,
                options: p.options.filter(o => o.cartItemOptionId !== cartItemOptionId)
              };
            }).filter(_temp)
          };
        }).filter(_temp2));
        return;
      }
      updateQuantity(cartItemOptionId, quantity);
      setShops(prev_0 => prev_0.map(shop_1 => {
        if (shop_1.mallVendorId !== mallVendorId) {
          return shop_1;
        }
        return {
          ...shop_1,
          products: shop_1.products.map(p_1 => {
            if (p_1.mallProductId !== mallProductId) {
              return p_1;
            }
            return {
              ...p_1,
              options: p_1.options.map(o_0 => o_0.cartItemOptionId === cartItemOptionId ? {
                ...o_0,
                quantity
              } : o_0)
            };
          })
        };
      }));
    };
    $[0] = deleteItems;
    $[1] = setShops;
    $[2] = updateQuantity;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const handleQuantityChange = t1;
  let t2;
  if ($[4] !== deleteItems || $[5] !== removeTarget || $[6] !== setShops || $[7] !== shops) {
    t2 = () => {
      if (!removeTarget) {
        return;
      }
      const {
        mallVendorId: mallVendorId_0,
        mallProductId: mallProductId_0,
        cartItemOptionId: cartItemOptionId_0
      } = removeTarget;
      if (cartItemOptionId_0) {
        deleteItems([cartItemOptionId_0]);
        setShops(prev_1 => prev_1.map(shop_2 => {
          if (shop_2.mallVendorId !== mallVendorId_0) {
            return shop_2;
          }
          return {
            ...shop_2,
            products: shop_2.products.map(p_2 => {
              if (p_2.mallProductId !== mallProductId_0) {
                return p_2;
              }
              return {
                ...p_2,
                options: p_2.options.filter(o_1 => o_1.cartItemOptionId !== cartItemOptionId_0)
              };
            }).filter(_temp3)
          };
        }).filter(_temp4));
        setRemoveTarget(null);
        return;
      }
      const optionIds = shops.find(s => s.mallVendorId === mallVendorId_0)?.products.find(p_4 => p_4.mallProductId === mallProductId_0)?.options.map(_temp5).filter(Boolean);
      if (optionIds?.length) {
        deleteItems(optionIds);
      }
      setShops(prev_2 => prev_2.map(shop_4 => {
        if (shop_4.mallVendorId !== mallVendorId_0) {
          return shop_4;
        }
        return {
          ...shop_4,
          products: shop_4.products.filter(p_5 => p_5.mallProductId !== mallProductId_0)
        };
      }).filter(_temp6));
      setRemoveTarget(null);
    };
    $[4] = deleteItems;
    $[5] = removeTarget;
    $[6] = setShops;
    $[7] = shops;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const confirmRemoveProduct = t2;
  let t3;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = (mallVendorId_1, mallProductId_1) => {
      setRemoveTarget({
        mallVendorId: mallVendorId_1,
        mallProductId: mallProductId_1
      });
    };
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  const handleRemoveProduct = t3;
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = (mallVendorId_2, mallProductId_2, cartItemOptionId_1) => {
      setRemoveTarget({
        mallVendorId: mallVendorId_2,
        mallProductId: mallProductId_2,
        cartItemOptionId: cartItemOptionId_1
      });
    };
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  const handleRemoveOption = t4;
  let t5;
  if ($[11] !== confirmRemoveProduct || $[12] !== handleQuantityChange || $[13] !== removeTarget) {
    t5 = {
      handleQuantityChange,
      removeTarget,
      setRemoveTarget,
      handleRemoveProduct,
      handleRemoveOption,
      confirmRemoveProduct
    };
    $[11] = confirmRemoveProduct;
    $[12] = handleQuantityChange;
    $[13] = removeTarget;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  return t5;
};
function _temp(p_0) {
  return p_0.options.length > 0;
}
function _temp2(shop_0) {
  return shop_0.products.length > 0;
}
function _temp3(p_3) {
  return p_3.options.length > 0;
}
function _temp4(shop_3) {
  return shop_3.products.length > 0;
}
function _temp5(o_2) {
  return o_2.cartItemOptionId;
}
function _temp6(shop_5) {
  return shop_5.products.length > 0;
}